/**
 * formatter在注册时需要包含两个属性
 * fn 函数本体
 * desc 说明文字
 */
import compare from './compare';
import object from './object';
import type from './type';
import math from './math';
import string from './string';
import time from './time';
import trick from './trick';

export const formatters = {
    compare,
    object,
    type,
    math,
    string,
    time,
    trick,
};

// 配置表单时的选项，格式按elementUI Cascader
export const formattersInfo = Object.keys(formatters).map(categoryKey => ({
    value: categoryKey,
    label: categoryKey,
    children: Object.keys(formatters[categoryKey]).map(formatterKey => ({
        value: formatterKey,
        label: formatterKey,
    })),
}));
